// Achievements + Stats sub-panels of the menu modal — preact components.
// Read-only display of state; subscribes via useStore so they repaint on
// any state change. Old imperative API (renderAchPanel) is preserved as
// a no-op shim for the current call sites; once everything's converted
// the shim can go away.
import { render } from 'preact';
import { ACHIEVEMENTS } from '../content/achievements.js';
import { state } from '../systems/state.js';
import { ACH_BONUS_PER_UNLOCK } from '../systems/rate.js';
import { fmt } from '../systems/util.js';
import { useStore } from './use-store.js';

function AchList() {
  useStore();
  return (
    <>
      {ACHIEVEMENTS.map(a => {
        const got = !!state.achievements[a.id];
        const hideMe = a.hidden && !got;
        return (
          <div key={a.id} className={'ach-row ' + (got ? 'earned' : 'locked')}>
            <div className="icon">{hideMe ? '❓' : a.icon}</div>
            <div className="info">
              <div className="name">{hideMe ? '???' : a.name}</div>
              <div className="desc">{hideMe ? '???' : a.desc}</div>
            </div>
          </div>
        );
      })}
    </>
  );
}

function Stats() {
  useStore();
  const taps = state.totalTaps || 0;
  const crits = state.criticalTaps || 0;
  const critPct = taps > 0 ? ((crits / taps) * 100).toFixed(1) : '0';
  const totalLifetime = (state.lifetimeBaked || 0) + state.lifetime;
  const stats = [
    ['total taps', fmt(taps)],
    ['critical hits', `${fmt(crits)} (${critPct}%)`],
    ['goldens tapped', fmt(state.goldensClicked || 0)],
    ['ascensions', String(state.ascensions || 0)],
    ['ripe crumbs 🍞', String(state.crumbs || 0)],
    ['longest streak', String(state.longestStreak || 0)],
    ['lifetime baked', fmt(totalLifetime)],
  ];
  return (
    <>
      {stats.map(([k, v]) => (
        <div key={k} className="stat">
          <span className="stat-k">{k}</span>
          <span className="stat-v">{v}</span>
        </div>
      ))}
    </>
  );
}

function AchSub() {
  useStore();
  const earned = ACHIEVEMENTS.filter(a => state.achievements[a.id]).length;
  const bonus = (earned * ACH_BONUS_PER_UNLOCK * 100).toFixed(0);
  return <span>{earned} of {ACHIEVEMENTS.length} · +{bonus}% rate</span>;
}

export function mountAchievements() {
  // Three separate DOM roots in index.html (legacy layout). Each gets its
  // own component mount.
  render(<AchList />, document.getElementById('ach-list'));
  render(<AchSub />, document.getElementById('ach-sub'));
  render(<Stats />, document.getElementById('stats'));
}

